// extracted by mini-css-extract-plugin
module.exports = {"comment_inactive":"ImagePanelV2_comment_inactive__2uIs7","container":"ImagePanelV2_container__3jOrU","container_uploaded":"ImagePanelV2_container_uploaded__2qfLN"};